import {BehaviorSubject, combineLatest, ReplaySubject} from 'rxjs';
import {filter, map, distinctUntilChanged} from 'rxjs/operators';
import {contractUtil} from '@px/helper/contract';
import {sd} from '@px/da/sd';
import {contractStorage} from '@px/storage/contract';
import {url$} from './url';
import {wsOpened$} from './ws';
import {wwData$} from './worker-data';

export const contract$ = new ReplaySubject<ContractPair>(1);

export const isPilotContract$ = new BehaviorSubject(false);

url$
  .pipe(
    filter((url: Url) => url && url.isPerpetual),
    map((url: Url) => url.tradePair as ContractPair),
    distinctUntilChanged()
  )
  .subscribe((tradePair) => {
    contract$.next(tradePair);
    const isPilotContract = contractUtil.isPilotContract(tradePair.perpProductSubType);
    if (isPilotContract !== isPilotContract$.getValue()) {
      isPilotContract$.next(isPilotContract);
    }
  });

combineLatest([url$, wsOpened$])
  .pipe(filter(([url]) => url && url.isPerpetual))
  .subscribe(([url]) => {
    const {tradeType, tradePair} = url;
    wwData$.next({type: 'state-symbol', tradeType, symbol: tradePair.symbol});
  });

contract$.subscribe((contract: ContractPair) => {
  const {symbol} = contract;
  sd.track('change_tradingview', {symbol, market: 'Contract'});
  const localData = contractStorage.readContractStorage();
  const isPilotContract = contractUtil.isPilotContract(contract.perpProductSubType);
  const lastSymbol = isPilotContract ? localData.pilotLastSymbol : localData.lastSymbol;
  if (symbol !== lastSymbol) {
    contractStorage.updateContractStorage(isPilotContract ? {pilotLastSymbol: symbol} : {lastSymbol: symbol});
  }
});
